import { NgModule } from '@angular/core';
import { SendFeedbackPage } from './send-feedback';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [
        SendFeedbackPage,
    ],
    imports: [
        PagesModule,
        ComponentsModule,
    ],
    exports: [
        SendFeedbackPage,
    ]
})
export class SendFeedbackPageModule { }
